export default {
  "9c835346-796b-4c27-8898-d6032f515cc5": {
    "name": "Cryptnox FIDO2"
  },
  "c5ef55ff-ad9a-4b9f-b580-adebafe026d0": {
    "name": "YubiKey 5Ci"
  },
  "39a5647e-1853-446c-a1f6-a79bae9f5bc7": {
    "name": "Vancosys Android Authenticator"
  },
  "3789da91-f943-46bc-95c3-50ea2012f03a": {
    "name": "NEOWAVE Winkeo FIDO2"
  },
  "fa2b99dc-9e39-4257-8f92-4a30d23c4118": {
    "name": "YubiKey 5 Series with NFC"
  },
  "4e768f2c-5fab-48b3-b300-220eb487752b": {
    "name": "Hideez Key 4 FIDO2 SDK"
  },
  "931327dd-c89b-406c-a81e-ed7058ef36c6": {
    "name": "Swissbit iShield FIDO2"
  },
  "e1a96183-5016-4f24-b55b-e3ae23614cc6": {
    "name": "ATKey.Pro CTAP2.0"
  },
  "08987058-cadc-4b81-b6e1-30de50dcbe96": {
    "name": "Windows Hello Hardware Authenticator"
  },
  "d91c5288-0ef0-49b7-b8ae-21ca0aa6b3f3": {
    "name": "KEY-ID FIDO2 Authenticator"
  },
  "ee041bce-25e5-4cdb-8f86-897fd6418464": {
    "name": "Feitian ePass FIDO2-NFC Authenticator"
  },
  "73bb0cd4-e502-49b8-9c6f-b59445bf720b": {
    "name": "YubiKey 5 FIPS Series"
  },
  "149a2021-8ef6-4133-96b8-81f8d5b7f1f5": {
    "name": "Security Key by Yubico with NFC"
  },
  "3b1adb99-0dfe-46fd-90b8-7f7614a4de2a": {
    "name": "GoTrust Idem Key FIDO2 Authenticator"
  },
  "f8a011f3-8c0a-4d15-8006-17111f9edc7d": {
    "name": "Security Key by Yubico"
  },
  "2c0df832-92de-4be1-8412-88a8f074df4a": {
    "name": "Feitian FIDO Smart Card"
  },
  "c5703116-972b-4851-a3e7-ae1259843399": {
    "name": "NEOWAVE Badgeo FIDO2"
  },
  "820d89ed-d65a-409e-85cb-f73f0578f82a": {
    "name": "Vancosys iOS Authenticator"
  },
  "b6ede29c-3772-412c-8a78-539c1f4c62d2": {
    "name": "Feitian BioPass FIDO2 Plus Authenticator"
  },
  "85203421-48f9-4355-9bc8-8a53846e5083": {
    "name": "YubiKey 5Ci FIPS"
  },
  "d821a7d4-e97c-4cb6-bd82-4237731fd4be": {
    "name": "Hyper FIDO Bio Security Key"
  },
  "516d3969-5a57-5651-5958-4e7a49434167": {
    "name": "SmartDisplayer BobeePass (NFC-BLE FIDO2 Authenticator)"
  },
  "b93fd961-f2e6-462f-b122-82002247de78": {
    "name": "Android Authenticator with SafetyNet Attestation"
  },
  "2fc0579f-8113-47ea-b116-bb5a8db9202a": {
    "name": "YubiKey 5 Series with NFC"
  },
  "9ddd1817-af5a-4672-a2b9-3e3dd95000a9": {
    "name": "Windows Hello VBS Hardware Authenticator"
  },
  "d8522d9f-575b-4866-88a9-ba99fa02f35b": {
    "name": "YubiKey Bio Series"
  },
  "692db549-7ae5-44d5-a1e5-dd20a493b723": {
    "name": "HID Crescendo Key"
  },
  "3e22415d-7fdf-4ea4-8a0c-dd60c4249b9d": {
    "name": "Feitian iePass FIDO Authenticator"
  },
  "aeb6569c-f8fb-4950-ac60-24ca2bbe2e52": {
    "name": "HID Crescendo C2300"
  },
  "9f0d8150-baa5-4c00-9299-ad62c8bb4e87": {
    "name": "GoTrust Idem Card FIDO2 Authenticator"
  },
  "12ded745-4bed-47d4-abaa-e713f51d6393": {
    "name": "Feitian AllinOne FIDO2 Authenticator"
  },
  "88bbd2f0-342a-42e7-9729-dd158be5407a": {
    "name": "Precision InnaIT Key FIDO 2 Level 2 certified"
  },
  "34f5766d-1536-4a24-9033-0e294e510fb0": {
    "name": "YubiKey 5 Series CTAP2.1 Preview 1 "
  },
  "83c47309-aabb-4108-8470-8be838b573cb": {
    "name": "YubiKey Bio Series (Enterprise Profile)"
  },
  "be727034-574a-f799-5c76-0929e0430973": {
    "name": "Crayonic KeyVault K1 (USB-NFC-BLE FIDO2 Authenticator)"
  },
  "b92c3f9a-c014-4056-887f-140a2501163b": {
    "name": "Security Key by Yubico"
  },
  "54d9fee8-e621-4291-8b18-7157b99c5bec": {
    "name": "HID Crescendo Enabled"
  },
  "6028b017-b1d4-4c02-b4b3-afcdafc96bb2": {
    "name": "Windows Hello Software Authenticator"
  },
  "6d44ba9b-f6ec-2e49-b930-0c8fe920cb73": {
    "name": "Security Key by Yubico with NFC"
  },
  "e416201b-afeb-41ca-a03d-2281c28322aa": {
    "name": "ATKey.Pro CTAP2.1"
  },
  "9f77e279-a6e2-4d58-b700-31e5943c6a98": {
    "name": "Hyper FIDO Pro"
  },
  "73402251-f2a8-4f03-873e-3cb6db604b03": {
    "name": "uTrust FIDO2 Security Key"
  },
  "c1f9a0bc-1dd2-404a-b27f-8e29047a43fd": {
    "name": "YubiKey 5 FIPS Series with NFC"
  },
  "504d7149-4e4c-3841-4555-55445a677357": {
    "name": "WiSECURE AuthTron USB FIDO2 Authenticator"
  },
  "cb69481e-8ff7-4039-93ec-0a2729a154a8": {
    "name": "YubiKey  5 Series"
  },
  "ee882879-721c-4913-9775-3dfcce97072a": {
    "name": "YubiKey 5 Series"
  },
  "8c97a730-3f7b-41a6-87d6-1e9b62bda6f0": {
    "name": "FT-JCOS FIDO Fingerprint Card"
  },
  "a1f52be5-dfab-4364-b51c-2bd496b14a56": {
    "name": "OCTATCO EzFinger2 FIDO2 AUTHENTICATOR"
  },
  "3e078ffd-4c54-4586-8baa-a77da113aec5": {
    "name": "Hideez Key 3 FIDO2"
  },
  "d41f5a69-b817-4144-a13c-9ebd6d9254d6": {
    "name": "ATKey.Card CTAP2.0"
  },
  "bc2fe499-0d8e-4ffe-96f3-94a82840cf8c": {
    "name": "OCTATCO EzQuant FIDO2 AUTHENTICATOR"
  },
  "1c086528-58d5-f211-823c-356786e36140": {
    "name": "Atos CardOS FIDO2"
  },
  "77010bd7-212a-4fc9-b236-d2ca5e9d4084": {
    "name": "Feitian BioPass FIDO2 Authenticator"
  },
  "833b721a-ff5f-4d00-bb2e-bdda3ec01e29": {
    "name": "Feitian ePass FIDO2 Authenticator"
  }
}